import React, { CSSProperties, FC, ReactNode, useMemo } from 'react';

import { getSizeSkin } from '../../lib/skin/getSizeSkin/getSizeSkin';
import { getColorSkin } from '../../lib/skin/getColorSkin/getColorSkin';

import { cnListBox, ListContext } from './utils';
import { ListWidth, ListSize } from './types';

export type ListBoxBaseProps = {
    /**
     * Размер элемента меню
     */
    size: ListSize;

    /**
     * Ширина меню.
     * auto — по контенту внутри, max — по контейнеру
     * @default auto
     */
    width?: ListWidth;

    /**
     * Инлайновые стили списка
     */
    style?: CSSProperties;

    /**
     * Класс списка
     */
    className?: string;

    children?: ReactNode;

    /**
     * Отображение выбора элемента ✓️
     * @default true
     */
    displaySelection?: boolean;
};

export const ListBoxBase: FC<ListBoxBaseProps> = function ListBoxBase(props) {
    const { size, width, className, style, children, displaySelection = false } = props;

    const listValue = useMemo(() => ({ size, displaySelection }), [size, displaySelection]);
    const selection = displaySelection;

    const sizeSkinClass = getSizeSkin(size);
    const isStrictWidth = typeof width === 'number';
    const cssMods = {
        width: isStrictWidth ? undefined : width,
        size,
        selection,
    };
    const boxStyle = {
        ...style,
        width: isStrictWidth ? `${width}px` : undefined,
    };

    const colorSkinClass = getColorSkin('gray-neutral', {});

    return (
        <ListContext.Provider value={listValue}>
            <div className={cnListBox(cssMods, [className, sizeSkinClass, colorSkinClass])} style={boxStyle}>
                {children}
            </div>
        </ListContext.Provider>
    );
};
